<template>
  <div class="">
    <div class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="row">

            <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
              <div class="col p-0">
                <div class="">
                  <MerchantMultiselect :multiple="true" v-model="merchantsFilter">
                  </MerchantMultiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
              <div class="col p-0">
                <div class="">
                  <StoreMultiselect :multiple="true" v-model="storesFilter">
                  </StoreMultiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
              <div class="col p-0">
                <div class="">
                  <TrafficGroupMultiselect :multiple="true" small v-model="trafficGroupsFilter">
                  </TrafficGroupMultiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                    <template v-slot="{ inputValue, togglePopover, inputEvents }">
                      <input
                        class="form-control form-control-sm"
                        :placeholder="helper.trans('labels.from_date')"
                        :value="inputValue"
                        @focus="togglePopover"
                        @change="inputEvents.change"
                      />
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                    <template v-slot="{ inputValue, togglePopover, inputEvents }">
                      <input
                        class="form-control form-control-sm"
                        :placeholder="helper.trans('labels.to_date')"
                        :value="inputValue"
                        @focus="togglePopover"
                        @change="inputEvents.change"
                      />
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
              <div class="col p-0">
                <div class="">
                  <TraderMultiselect :multiple="true" v-model="tradersFilter">
                  </TraderMultiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <Multiselect id="methods"
                               class="multiselect-sm"
                               v-model="requestDTO.methods"
                               :options="store.getters['currencyMethods/methods']()"
                               :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                               :multiple="true"
                               select-label="Select"
                               :placeholder="helper.trans('labels.payment_methods')"
                  >
                    <template #option="props">
                      <div class="d-flex flex-row align-items-center gap-2">
                        <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                        <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                      </div>
                    </template>
                  </Multiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <Multiselect id="options"
                               class="multiselect-sm"
                               v-model="requestDTO.options"
                               :options="store.getters['currencyMethods/options']()"
                               :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                               :multiple="true"
                               select-label="Select"
                               :placeholder="helper.trans('labels.payment_options')"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <Multiselect id="currency"
                               class="multiselect-sm multiselect-capitalize"
                               v-model="requestDTO.currency"
                               :options="store.getters['currencyMethods/currencies']"
                               :custom-label="(opt) => opt"
                               :multiple="false"
                               select-label="Select"
                               :placeholder="helper.trans('labels.currency')"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
              <div class="col p-0">
                <div class="">
                  <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountFrom" class="form-control form-control-sm" :placeholder="helper.trans('labels.from_sum')" />
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" v-if="isAdmin || isOperator">
              <div class="col p-0">
                <div class="">
                  <input type="text" :disabled="!requestDTO.currency" v-model="requestDTO.amountTo" class="form-control form-control-sm" :placeholder="helper.trans('labels.to_sum')" />
                </div>
              </div>
            </div>

            <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
              <div class="col p-0">
                <div class="">
                  <Multiselect id="types"
                               class="multiselect-sm"
                               v-model="requestDTO.types"
                               :options="Object.values(Direction)"
                               :custom-label="(opt) => helper.trans(`direction.${opt}`)"
                               :multiple="true"
                               select-label="Select"
                               :placeholder="helper.trans('labels.type')"
                  >
                  </Multiselect>
                </div>
              </div>
            </div>

            <div class="form-group mb-2 col">
              <div class="col-auto p-0 text-end ">
                <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
              </div>
            </div>

          </div>
          <div class="row mt-3" >
            <div class="form-group mb-2 col-sm-12 me-2">
              <div class="col p-0">
                <div class="">
                  <label class="me-2">{{helper.trans('labels.group_by')}}</label>
                  <template v-for="period in [10,30,60]">
                    <input type="radio" v-model="requestDTO.periodMinutes" :value="period" class="btn-check" name="options-outlined" :id="`group-${period}`" autocomplete="off">
                    <label class="btn btn-sm btn-outline-dark me-2" :for="`group-${period}`">{{period}} {{helper.trans('labels.minutes')}}</label>
                  </template>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <LoaderWrapper ref="loaderOnline" class="h-100">
    <div class="row m-4 mb-0 mt-0 ms-3 me-3">
      <div class="col-xs-12 col-lg-6 mb-3 ps-2 pe-2">
          <div class="card card-default h-100">
            <div class="card-body p-1 p-lg-2">
              <label class="d-block text-center">{{ helper.trans('labels.count_online_stat')}}</label>
              <Bar
                :chart-options="onlineChartOptions"
                :chart-data="onlineChartData"
              />
            </div>
          </div>
      </div>

      <div class="col-xs-12 col-lg-6 mb-3 ps-2 pe-2">
          <div class="card card-default h-100">
            <div class="card-body p-1 p-lg-2">
              <label class="d-block text-center">{{ helper.trans('labels.volume_online_stat')}}</label>
              <Bar
                :chart-options="onlineVolumeOptions"
                :chart-data="onlineVolumeData"
              />
            </div>
          </div>
      </div>
    </div>

      <div class="row m-4 mb-0 mt-0 ms-3 me-3">

        <div class="col-xs-12 col-lg-6 mb-3 ps-2 pe-2">
          <div class="card card-default h-100">
            <div class="card-body p-1 p-lg-2">
              <label class="d-block text-center">{{ helper.trans('labels.traders')}}</label>
              <Bar
                :chart-options="onlineChartOptions"
                :chart-data="onlineTradersData"
              />
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-lg-6 mb-3 ps-2 pe-2">
          <div class="card card-default h-100">
            <div class="card-body p-1 p-lg-2">
              <label class="d-block text-center">{{ helper.trans('labels.amount_online_stat', {minutes: requestDTO.periodMinutes })}}</label>
              <Bar
                :chart-options="onlineAmountChartOptions"
                :chart-data="onlineAmountsData"
              />
            </div>
          </div>
        </div>
      </div>

    </LoaderWrapper>
  </div>
</template>
<script lang="ts">
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import StatisticSummary from "@/views/StatisticSummary.vue";
import {Bar} from "vue-chartjs";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {ChartOptions} from "chart.js";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, PointElement, CategoryScale, LinearScale } from 'chart.js'
import {DatePicker} from "v-calendar";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import StoreMultiselect from "@/components/StoreMultiselect.vue";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import TraderDTO from "@/models/TraderDTO";
import moment from "moment";
import MoneyDTO from "@/models/MoneyDTO";
import Multiselect from "vue-multiselect";
import TrafficGroupMultiselect from "@/components/TrafficGroupMultiselect.vue";
import TrafficGroupDTO from "@/models/TrafficGroupDTO";
import {Direction} from "@/models/enum/Direction";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import MerchantMultiselect from "@/components/MerchantMultiselect.vue";
import MerchantDTO from "@/models/MerchantDTO";

const api = new APIClient();
const notification = useNotification()

ChartJS.register(Title, Tooltip, Legend, BarElement, PointElement, CategoryScale, LinearScale)
ChartJS.defaults.color = "#c0ccda";

interface OnlineItemDTO {
  invoices_count: number,
  deals_count: number,
  traders_count: number,
  invoices_amount: number,
  completed_deals_amount: number,
  completed_deals_count: number,
  deals_amount: number,
  currency: string,
  time: string
}

interface OnlineAmountItemDTO {
  amount: number,
  amount_to?: number | null,
  range?: number,
  currency: string,
  invoices_count: number,
  deals_count: number,
  completed_deals_count: number,
}

const onlineVolumeOptions: ChartOptions = {
  animation: {
    duration: 0
  },
  responsive: true,
  aspectRatio: 16/8,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      callbacks: {
        label: function(context) {
          return (context.dataset.label || '') +': ' + numberFormatter.formatMoney({amount: context.raw, currency: (context.dataset as any).currency || 'RUB', subunit:2} as MoneyDTO);
        }
      }
    }
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    x: {
      ticks: {
        callback: function(value: number): string {
          return dateHelper.format(this.getLabelForValue(value), 'DD-MM HH:mm');
        }
      },
      stacked: true
    },
    y: {
      stacked: false,
      ticks: {
        beginAtZero: true,
      },
    }
  }
} as ChartOptions;

const onlineAmountChartOptions: ChartOptions = {
  animation: {
    duration: 0
  },
  responsive: true,
  aspectRatio: 16/8,
  plugins: {
    legend: {
      display: false
    },
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    x: {
      ticks: {
        callback: function(value: number): string {
          return this.getLabelForValue(value);
        }
      },
      stacked: true
    },
    y: {
      stacked: false,
      ticks: {
        beginAtZero: true,
      },
    }
  }
} as ChartOptions;

const onlineChartOptions: ChartOptions = {
  animation: {
    duration: 0
  },
  responsive: true,
  aspectRatio: 16/8,
  plugins: {
    legend: {
      display: false
    },
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  scales: {
    x: {
      ticks: {
        callback: function(value: number): string {
          return dateHelper.format(this.getLabelForValue(value), 'DD-MM HH:mm');
        }
      },
      stacked: true
    },
    y: {
      stacked: false,
      ticks: {
        beginAtZero: true,
      },
    }
  }
} as ChartOptions;

export default defineComponent({
  components: {
    MerchantMultiselect,
    PayMethodIcon,
    TrafficGroupMultiselect,
    StatisticSummary,
    LoaderWrapper,
    Bar,
    DatePicker,
    TraderMultiselect,
    StoreMultiselect,
    Multiselect
  },
  setup() {
    const store = useStore()
    const loaderOnline = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      tradersFilter: [] as TraderDTO[],
      merchantsFilter: [] as MerchantDTO[],
      storesFilter: [] as MerchantStoreDTO[],
      trafficGroupsFilter: [] as TrafficGroupDTO[],
      requestDTO: {
        fromDate: moment().format('YYYY-MM-DD 00:00:00'),
        periodMinutes: 10,
      } as any,
      onlineChartData: {
        labels: [] as string[],
        datasets: [
          {
            label: helper.trans('labels.completed_deals'),
            backgroundColor: '#2bc568',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          },
          {
            label: helper.trans('labels.deals'),
            backgroundColor: '#4e8ae5',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          },
          {
            label: helper.trans('labels.invoices'),
            backgroundColor: '#e93939',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          }
        ]
      },
      onlineAmountsData: {
        labels: [] as string[],
        datasets: [
          {
            label: helper.trans('labels.completed_deals'),
            backgroundColor: '#2bc568',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          },
          {
            label: helper.trans('labels.deals'),
            backgroundColor: '#4e8ae5',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          },
          {
            label: helper.trans('labels.invoices'),
            backgroundColor: '#e93939',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          }
        ]
      },
      onlineVolumeData: {
        labels: [] as string[],
        datasets: [
          {
            label: helper.trans('labels.completed_deals'),
            backgroundColor: '#2bc568',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          },
          {
            label: helper.trans('labels.deals'),
            backgroundColor: '#4e8ae5',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          },
          {
            label: helper.trans('labels.invoices'),
            backgroundColor: '#e93939',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
            stack: 1,
          }
        ]
      },
      onlineTradersData: {
        labels: [] as string[],
        datasets: [
          {
            label: helper.trans('labels.traders'),
            backgroundColor: '#4e8ae5',
            borderRadius: { topLeft: 6, topRight: 6, bottomLeft: 6, bottomRight: 6 },
            borderSkipped: false,
            data: [] as Number[],
          },
        ]
      }
    });

    const loadOnlineData = async () => {
      loaderOnline.value?.show();

      state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
      state.requestDTO.storeIds = state.storesFilter.map((value) => value.id)
      state.requestDTO.merchantIds = state.merchantsFilter.map((value) => value.id)
      state.requestDTO.trafficGroupsIds = state.trafficGroupsFilter.map((value) => value.id)

      const rows = await api.statisticOnlineSummary({
        ...state.requestDTO,
        fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
        toDate: dateHelper.toUTC(state.requestDTO.toDate),
      }) as OnlineItemDTO[]

      let labels = [] as string[];

      let invoicesCount = [];
      let dealsCount = [];
      let completedDealsCount = [];
      let tradersCount = [];
      let completedDealsAmount = [];
      let dealsAmount = [];
      let invoicesAmount = [];
      let amountsCurrency = state.requestDTO.currency || 'RUB';
      for (const row of rows) {
        labels.push(dateHelper.format(row.time))
        invoicesCount.push(row.invoices_count)
        dealsCount.push(row.deals_count)
        completedDealsCount.push(row.completed_deals_count)

        tradersCount.push(row.traders_count)

        completedDealsAmount.push(row.completed_deals_amount)
        dealsAmount.push(row.deals_amount)
        invoicesAmount.push(row.invoices_amount)
        amountsCurrency = row.currency || amountsCurrency
      }

      state.onlineChartData.labels = labels;
      state.onlineTradersData.labels = labels;
      state.onlineVolumeData.labels = labels;

      state.onlineChartData.datasets[0].data = completedDealsCount;
      state.onlineChartData.datasets[1].data = dealsCount;
      state.onlineChartData.datasets[2].data = invoicesCount;

      state.onlineTradersData.datasets[0].data = tradersCount;

      state.onlineVolumeData.datasets[0].data = completedDealsAmount;
      state.onlineVolumeData.datasets[1].data = dealsAmount;
      state.onlineVolumeData.datasets[2].data = invoicesAmount;
      (state.onlineVolumeData.datasets[0] as any).currency = amountsCurrency;
      (state.onlineVolumeData.datasets[1] as any).currency = amountsCurrency;
      (state.onlineVolumeData.datasets[2] as any).currency = amountsCurrency;

      const amountsSummary = await api.statisticOnlineSummaryAmounts({
        ...state.requestDTO,
        fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
        toDate: dateHelper.toUTC(state.requestDTO.toDate),
      }) as OnlineAmountItemDTO[]
      labels = [];
      invoicesCount = [];
      dealsCount = [];
      completedDealsCount = [];
      for (const row of amountsSummary) {
        const currency = row.currency || state.requestDTO.currency || 'RUB'
        if (row.amount_to === null) {
          labels.push(`${row.amount}+ ${currency}`)
        } else {
          const amountTo = row.amount_to || row.amount + (row.range || 500)
          labels.push(`${row.amount} - ${amountTo} ${currency}`)
        }
        invoicesCount.push(row.invoices_count)
        dealsCount.push(row.deals_count)
        completedDealsCount.push(row.completed_deals_count)
      }

      state.onlineAmountsData.labels = labels;

      state.onlineAmountsData.datasets[0].data = completedDealsCount;
      state.onlineAmountsData.datasets[1].data = dealsCount;
      state.onlineAmountsData.datasets[2].data = invoicesCount;

      loaderOnline.value?.hide();
    }

    const clearFilters = async () => {
      state.tradersFilter = [];
      state.merchantsFilter = [];
      state.storesFilter = [];
      state.trafficGroupsFilter = [];
      state.requestDTO = {
        fromDate: moment().format('YYYY-MM-DD 00:00:00'),
        periodMinutes: 10,
        methods: [],
        options: []
      }
      loadOnlineData()
    }

    const applyFilters = async () => {
      loadOnlineData()
    }

    onMounted(() => {
      loadOnlineData();
    });

    return {
      ...toRefs(state),
      applyFilters,
      clearFilters,
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTrader: computed(() => store.getters.isTrader),
      isTeamLead: computed(() => store.getters.isTeamLead),
      isReferral: computed(() => store.getters.isReferral),
      isMerchant: computed(() => store.getters.isMerchant),
      dateHelper,
      numberFormatter,
      helper,
      loaderOnline,
      onlineChartOptions,
      onlineVolumeOptions,
      onlineAmountChartOptions,
      store,
      Direction
    }
  }
})
</script>
